/**
 * Online Security
 *
 * Exposes its content-script stylesheet plus an assets/images/* grant to every origin.
 *
 * Manifest verified against version 7.6.0.
 */

import { probeFetch, probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'llbcnfanfmjhpedaedhbcnpgeepdnnok';

export const onlineSecurity: ExtensionDefinition = {
  id: ID,
  name: 'Online Security',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 11_000_000,
  signals: [
    {
      id: 'war-content-styles',
      kind: 'web-accessible-resource',
      description: 'Fetch content.styles.css — the content script stylesheet, exposed to <all_urls>.',
      weight: 1,
      run: () => probeFetch(ID, 'content.styles.css'),
    },
    {
      id: 'war-check-icon',
      kind: 'web-accessible-resource',
      description: 'Load assets/images/check.svg via <img> to corroborate.',
      weight: 0.5,
      run: () => probeImage(ID, 'assets/images/check.svg'),
    },
  ],
};
